import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export type DataRoomFileState = {
  selectedFileVersionId: {
    [fileId: string]: string;
  };
};

const initialState: DataRoomFileState = {
  selectedFileVersionId: {},
};

export const { actions, reducer } = createSlice({
  name: "dataRoomFile",
  initialState,
  reducers: {
    setSelectedFileVersionId: (
      state,
      action: PayloadAction<{ fileId: string; versionId: string }>
    ) => {
      state.selectedFileVersionId[action.payload.fileId] =
        action.payload.versionId;
    },
  },
});
